// Where the triage panel sits relative to the thread (SA-1347, spec
// 2026-10-21-inbox-triage-beside-the-thread-design.md). The rule
// reads the PANE's measured width, never the viewport or a container query:
// the panel and the thread must choose together, and the width also moves with
// the list edge and the sidebar (§3.1). From BESIDE_MIN_PX the pane is a grid:
// the panel takes column 2 whenever it renders (PANE_BESIDE); with no panel the
// thread is one column capped at 72rem (PANE_ALONE; §3.5 as amended).

export const BESIDE_MIN_PX = 1280

export type PaneLayout = 'stacked' | 'beside'

export function paneLayout(width: number): PaneLayout {
  return width >= BESIDE_MIN_PX ? 'beside' : 'stacked'
}

const ROWS = 'grid-rows-[auto_auto_minmax(0,1fr)_auto_auto_auto_auto_auto]'

// Eight rows, one per thread child, so an absent conditional child leaves an
// empty 0-height row and the messages row (3) stays the flexible one.
export const PANE_BESIDE = `grid min-h-0 grid-cols-[minmax(0,72rem)_clamp(32rem,38%,44rem)] ${ROWS} justify-start`
export const PANE_ALONE = `grid min-h-0 grid-cols-[minmax(0,72rem)] ${ROWS} justify-start`

export const THREAD_CHILD: Record<
  'header' | 'emailHeader' | 'messages' | 'bankTransfer' | 'escalation' | 'needsReview' | 'draft' | 'composer',
  string
> = {
  header: 'col-start-1 row-start-1',
  emailHeader: 'col-start-1 row-start-2',
  messages: 'col-start-1 row-start-3',
  bankTransfer: 'col-start-1 row-start-4',
  escalation: 'col-start-1 row-start-5',
  needsReview: 'col-start-1 row-start-6',
  draft: 'col-start-1 row-start-7',
  composer: 'col-start-1 row-start-8',
}

export const PANEL_BESIDE = 'col-start-2 row-span-full min-h-0 border-l border-border overflow-y-auto'
